import styled from 'styled-components';
import CalculateDistanceInput from './CalculateDistanceInput';
import CalculateDistanceIcon from '../../../../new-components/svg-icons/CalculateDistanceIcon';
import { useTranslation } from 'next-i18next';

interface CalculateDistanceDrawerProps {
  isSahel?: boolean;
}

const CalculateDistanceDrawer = ({ isSahel }: CalculateDistanceDrawerProps) => {
  const { t } = useTranslation('map');

  return (
    <Container>
      <div className="logo">
        <CalculateDistanceIcon stroke="#015C9A" />
      </div>

      <div className="content">
        <h2>{t('calculate_distance')}</h2>

        <span className="content">{t('calculate_distance_tooltip')}</span>
      </div>

      <div className="input">
        <CalculateDistanceInput destination="a" isSahel={isSahel} />
        <CalculateDistanceInput destination="b" isSahel={isSahel} />
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  padding-top: 32px;
  align-self: stretch;
  padding-bottom: 300px;

  .logo {
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e6eff5;
    padding: 32px;
    border-radius: 360px;

    svg {
      width: 120px;
      height: 120px;
    }
  }

  .input {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .calculate-distance-btn {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #015c9a;
    color: #ffffff;
    font-size: 15px;
    font-family: materialBold;
    border-radius: 8px;
    border: none;
    text-transform: capitalize;

    :disabled {
      background-color: #e6eff5;
      color: grey;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-align: center;
    h2 {
      color: #2c3138;
      font-size: 24px;
      font-family: materialBold;
    }

    span {
    }

    font-size: 16px;
    color: #697586;
    font-family: materialRegular;
  }
`;

export default CalculateDistanceDrawer;
